import { render, staticRenderFns } from "./autohomesms.vue?vue&type=template&id=65054058&scoped=true"
import script from "./autohomesms.vue?vue&type=script&lang=js"
export * from "./autohomesms.vue?vue&type=script&lang=js"
import style0 from "./autohomesms.vue?vue&type=style&index=0&id=65054058&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65054058",
  null
  
)

export default component.exports